import { FC } from 'react';

import { AppVersionTitle, FooterContainer, FooterTitle, Root } from './styles';
import { Props } from './types';

const Footer: FC<Props> = ({ className }) => {
  return (
    <Root className={className}>
      <FooterContainer>
        <FooterTitle>© 2026 PMC Analytics<AppVersionTitle> v.{/*gitBranchName*/}2.18.2</AppVersionTitle></FooterTitle>
      </FooterContainer>
      
    </Root>
  );
};

export default Footer;
